import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { VirtualOfficeCard } from './VirtualOfficeCard';

const Box = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }
`;

interface VirtualOfficeGridProps {
  setSelected: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setStep: Dispatch<SetStateAction<number>>;
  licences: any;
}

export const VirtualOfficeGrid = ({
  setSelected,
  setIsOpen,
  setStep,
  licences
}: VirtualOfficeGridProps) => {
  return (
    <Box>
      {licences?.map((plan: any, i: number) => (
        <VirtualOfficeCard
          key={i}
          plan={plan}
          setSelected={setSelected}
          setIsOpen={setIsOpen}
          setStep={setStep}
        />
      ))}
    </Box>
  );
};
